import React, { ReactNode } from "react";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  error: Error | null;
}

export class AppErrorBoundary extends React.Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // Without an explicit log here, production Tauri builds swallow the
    // error silently — the user sees the Reload card but nothing reaches
    // the console for diagnosis. Keep this synchronous + cheap; the React
    // dev overlay still runs in dev regardless.
    console.error("AppErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="sign-in-gate">
        <div className="sign-in-status" role="alert">
          <h1>Steerly hit a runtime error</h1>
          <p>{error.message || "Reload the app and try again."}</p>
          <div className="sign-in-status__actions">
            <button type="button" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </div>
      </div>
    );
  }
}
